module.exports = __webpack_public_path__ + "static/img/gift-list-btn.4a2f0b4e.png";